"use strict";

!function($, window, document) {
    const $win = $(window), $html = ($(document), $("html")), $body = $(document.body);
    $(".header");
    function setCSSVariable(name, value, unit = "", $element = $html) {
        $element.css(`--${name}`, `${value}${unit}`);
    }
    $(".js-accordion .accordion__head").on("click", (e => {
        $(e.currentTarget).siblings(".accordion__body").slideToggle().parents(".accordion__section").toggleClass("is-active");
    }));
    $(".js-nav-trigger").on("click", (e => {
        e.preventDefault(), $body.toggleClass("is-menu-expanded");
    }));
    $(".js-player");
    const breakpointMobile = window.matchMedia("(max-width: 767px)");
    function setNewSrcToVideo(player) {
        let newSrc;
        newSrc = player.getAttribute("data-plyr-provider") ? breakpointMobile.matches ? player.getAttribute("data-embed-mobile") : player.getAttribute("data-embed-desktop") : breakpointMobile.matches ? player.getAttribute("data-src-mobile") : player.getAttribute("data-src-desktop"), 
        player.getAttribute("data-plyr-provider") ? player.setAttribute("data-plyr-embed-id", newSrc) : player.setAttribute("src", newSrc);
    }
    function reinitVideoChangeSrcBasedOnWidth(players, options) {
        players || ($(".media--toggle-desktop-mobile").each((function() {
            this.plyr && this.plyr.destroy();
        })), players = $(".js-player-toggle-desktop-mobile"));
        for (let i = 0; i < players.length; i++) {
            setNewSrcToVideo(players[i]);
        }
        !function initPlyrVideo(players, options) {
            players.each((function() {
                if (!this) return;
                const $currentMedia = $(this).closest(".media"), mediaAutoplay = "click" !== $currentMedia.data("autoplay") && !1 !== $currentMedia.data("autoplay") && "hover" !== $currentMedia.data("autoplay"), player = new Plyr(this, {
                    volume: 0,
                    autoplay: !1,
                    clickToPlay: !1,
                    controls: [],
                    muted: !0,
                    loop: {
                        active: !0
                    },
                    ...options
                });
                let observer = new IntersectionObserver((entries => {
                    entries.map((entry => {
                        entry.isIntersecting && mediaAutoplay && player ? player.play() : player.pause();
                    }));
                }), {
                    rootMargin: "0px +200px",
                    threshold: 0
                });
                $currentMedia[0].plyr = player, player.on("ready", (() => {
                    muteUnmuteVideo($currentMedia), player.pause(), observer.observe($currentMedia[0]);
                })), player.on("play", (() => {
                    $currentMedia.addClass("is-played");
                })), player.on("pause", (() => {
                    $currentMedia.removeClass("is-played").find(".js-play-btn").removeClass("is-played");
                }));
            }));
        }(players, options);
    }
    $.event.special.widthResize = {
        setup: function() {
            const $this = $(this);
            $this.data("currentWidth", $this.width()), $this.on("resize.widthResize", (function() {
                const newWidth = $this.width();
                newWidth !== $this.data("currentWidth") && $this.data("currentWidth", newWidth).trigger("widthResize");
            }));
        },
        teardown: function() {
            $(this).off("resize.widthResize");
        }
    }, $(document).on("click", ".media", (function(e) {
        e.preventDefault();
        const $media = $(this), $playBtn = $media.find(".js-play-btn"), currentPlayer = $media[0].plyr;
        $playBtn.length && ($playBtn.toggleClass("is-played"), $playBtn.hasClass("is-played") ? currentPlayer.play() : currentPlayer.pause());
    }));
    const muteUnmuteVideo = video => {
        const player = video[0].plyr;
        video.data("mute") ? (player.muted = !0, player.volume = 0, player.decreaseVolume(100)) : (player.muted = !1, 
        player.volume = 1, player.increaseVolume(100));
    };
    $(".js-trigger-popup").on("click", (function(e) {
        e.preventDefault(), $("#popup-team").append('<svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>'), 
        $("#popup-team .popup__inner").hide();
        let video = $(this).data("video"), caption = $(this).data("caption");
        $.ajax({
            url: ajax.ajaxurl + "video-popup",
            data: {
                video: video,
                caption: caption
            },
            success: function(response) {
                $("#popup-team .popup__content").html(response), $("#popup-team .popup__inner").fadeIn("fast"), 
                $(".spinner").remove();
                reinitVideoChangeSrcBasedOnWidth($(".js-player-toggle-desktop-mobile"), {
                    controls: [ "play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen" ],
                    vimeo: {
                        background: !1,
                        customControls: !1
                    },
                    clickToPlay: !0
                }), setTimeout((function(e) {
                    console.log(window);
                }), 3e3);
            }
        });
    })), $win.on("load", (() => {
        $body.addClass("is-loaded");
    })).on("load scroll", (() => {
        $(".js-animate").each(((_, element) => {
            const $this = $(element), animateStart = $this.attr("data-start");
            $this.offset().top + $this.outerHeight() * animateStart < $win.scrollTop() + $win.outerHeight() && $this.addClass("is-animated");
        })), (() => {
            const scrollTop = $win.scrollTop();
            $body.toggleClass("is-header-passed", 170 < scrollTop).toggleClass("is-fixed-header-visible", 255 < scrollTop);
        })();
    })), $(".nav a").on("focus blur", (function(e) {
        $("body").toggleClass("is-menu-expanded", "focus" === e.type);
    })), $(".js-popup-close").on("click", (e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        $this.parents(".popup").removeClass("is-visible");
        const player = $this.parents(".popup").find(".media");
        player && player.remove();
    })), function initSelectric(element) {
        $(element).length && $(element).is("select") && $(element).selectric({
            disableOnMobile: !1,
            nativeOnMobile: !1,
            onInit: function() {
                const $wrp = $(this).closest(".selectric-wrapper"), $select = $wrp.find(".selectric-hide-select");
                if ($wrp.on("keydown", (function(e) {
                    if ($wrp.hasClass("selectric-open") && ("ArrowDown" === e.key || "ArrowUp" === e.key)) {
                        e.preventDefault();
                        const $items = $wrp.find(".selectric-items li"), currentIndex = $items.filter(".selected").index();
                        let newIndex;
                        newIndex = "ArrowDown" === e.key ? currentIndex < $items.length - 1 ? currentIndex + 1 : currentIndex : currentIndex > 0 ? currentIndex - 1 : 0, 
                        $items.removeClass("selected highlighted"), $items.eq(newIndex).addClass("selected highlighted"), 
                        $(element).prop("selectedIndex", newIndex).selectric("refresh");
                    }
                })), $wrp.parent().data("label")?.length > 0) {
                    const $selectedOption = $select.find("option:selected").text(), dataLabel = $wrp.parent().data("label") + ` <strong>(${$selectedOption})</strong>`;
                    $wrp.find(".label").html(dataLabel);
                }
            },
            onOpen: function() {
                $(".selectric-input").blur();
                const $fixer = $(this).closest(".selectric-wrapper").find(".selectric-items");
                $fixer.fadeOut(), $fixer.stop(!0, !0).hide().fadeIn();
            },
            onClose: function() {
                const $fixer = $(this).closest(".selectric-wrapper").find(".selectric-items");
                $fixer.fadeIn(), $fixer.stop(!0, !0).show().fadeOut();
            },
            onChange: function() {
                const $wrp = $(this).closest(".selectric-wrapper"), $values = $wrp.find(".selectric-hide-select option"), $select = $wrp.find(".selectric-hide-select");
                if ($values.parent().find("option:selected").prop("selected", !1), $($values.get($wrp.find(".selected").index())).prop("selected", !0).parent().trigger("change"), 
                $wrp.parent().data("label")?.length > 0) {
                    const $selectedOption = $select.find("option:selected").text(), dataLabel = $wrp.parent().data("label") + ` <strong>(${$selectedOption})</strong>`;
                    $wrp.find(".label").html(dataLabel);
                }
                $wrp.addClass("is-selected");
            }
        });
    }($("select")), setCSSVariable("footer-height", $(".footer").outerHeight(), "px"), 
    setCSSVariable("header-height", $(".header").outerHeight(), "px"), $win.on("resize", (function() {
        setCSSVariable("footer-height", $(".footer").outerHeight(), "px"), setCSSVariable("header-height", $(".header").outerHeight(), "px");
    }));
}(jQuery, window, document);